import React, { useState, useEffect } from 'react';
import { useDropzone } from 'react-dropzone';
import { Check, X } from 'react-feather';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import FileUploadDisplay from '../../components/FileUploadDisplay';

const UploadLetter = ({ onFileSelect, initialFile }) => {
	const [currentFile, setCurrentFile] = useState(null);

	// Load initial file when component mounts or initialFile changes
	useEffect(() => {
		if (initialFile && currentFile !== initialFile) {
			// If initialFile is a File object, use it directly
			if (initialFile instanceof File) {
				setCurrentFile(initialFile);
			}
			// If initialFile is a string (S3 URL), set it as current file
			else if (typeof initialFile === 'string') {
				setCurrentFile(initialFile);
			}
			// If initialFile is an object with file data
			else if (initialFile && typeof initialFile === 'object') {
				if (initialFile.url) {
					setCurrentFile(initialFile.url);
				} else if (initialFile.data) {
					const file = new File([initialFile.data], initialFile.name || 'recommendation.pdf', {
						type: 'application/pdf',
					});
					setCurrentFile(file);
				}
			}
		}
		if (!initialFile && currentFile) {
			setCurrentFile(null);
		}
		// eslint-disable-next-line
	}, [initialFile]);

	const { getRootProps, getInputProps, isDragActive, isDragAccept, isDragReject } = useDropzone({
		accept: { 'application/pdf': [] },
		maxFiles: 1,
		onDrop: (acceptedFiles) => {
			// Only allow files <= 5MB
			const validFiles = acceptedFiles.filter((file) => file.size <= 5 * 1024 * 1024);
			if (validFiles.length === 0) {
				toast.error('File too large. Maximum allowed size is 5MB.');
				return;
			}
			setCurrentFile(validFiles[0]);
			onFileSelect(validFiles[0]);
			toast.success('Recommendation letter selected successfully');
		},
	});

	const handleRemoveFile = () => {
		setCurrentFile(null);
		onFileSelect(null);
		toast.info('Recommendation letter removed');
	};

	return (
		   <>
			   <div className="dropzone">
				   <div {...getRootProps({ className: 'dropzone-upload-wrapper' })}>
					   <input {...getInputProps()} />
					   <div className="dropzone-inner-wrapper">
						   {isDragAccept && (
							   <div>
								   <div className="d-100 btn-icon mb-3 hover-scale-lg bg-success shadow-success-sm rounded-circle text-white">
									   <Check className="d-50" />
								   </div>
								   <div className="font-size-sm text-success">PDF file accepted!</div>
							   </div>
						   )}
						   {isDragReject && (
							   <div>
								   <div className="d-100 btn-icon mb-3 hover-scale-lg bg-danger shadow-danger-sm rounded-circle text-white">
									   <X className="d-60" />
								   </div>
								   <div className="font-size-sm text-danger">Only PDF files are allowed!</div>
							   </div>
						   )}
						   {!isDragActive && (
							   <div className="upload_detail text-center">
								   <img src="/assets/images/upload.svg" alt="Upload" />
								   <h4>Upload Recommendation Letter</h4>
								   <h5>Please upload recommendation letter in PDF format (max 5MB)</h5>
							   </div>
						   )}
					   </div>
				   </div>
			   </div>
			   {currentFile && (
				   <div className="mt-3">
					   <FileUploadDisplay
						   file={currentFile}
						   onRemove={handleRemoveFile}
						   showDownload={true}
						   showView={true}
						   showRemove={true}
					   />
				   </div>
			   )}
		   </>
	);
};

export default UploadLetter;
